// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34v9x","newExpiryDate":"styles_newExpiryDate__QV1ux","footer":"styles_footer__hDGna"};